module.exports = __webpack_public_path__ + "img/trial4-2.69e24164.png";